import React from 'react';

type WidgetTabsContentProps = {
    children: React.ReactNode;
};

const WidgetTabsContent: React.FC<WidgetTabsContentProps> = ({ children }) => {
    return <>{children}</>;
};

export default WidgetTabsContent;
